@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.container {
  @include separator-bottom;
}

.slider {
  display: flex;
  margin-top: 2.625rem;
  margin-bottom: 2.625rem;

  @include mobile {
    border-top: 1px solid $separator;
    @include separator-bottom;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

.transaction {
  flex-shrink: 1;
  flex-grow: 1;
  text-align: center;

  @include mobile {
    margin: 1.78125rem .25rem 1.78125rem;
  }
}

.transaction:first-child {
  margin-left: 0;
  margin-right: 0;
}
.transaction:last-child {
  margin-right: 0;
  margin-left: 0;

}

.points {
  font-size: 2rem;
  font-weight: 600;
  color: $grey;
  padding-left: 1rem;
  padding-right: 1rem;

  @include mobile {
    color: #707070;
    font-size: 1.375rem;
    font-weight: 600;
    padding-left: .25rem;
    padding-right: .25rem;
  }

  @include tablet-only {
    font-size: 4rem;
    font-weight: 600;
  }
}

.date {
  color: $grey-text;
  font-weight: 100;
  font-size: .75rem;
  line-height: .75rem;

  @include mobile {
    font-size: .5rem;
  }
}

.subType {
  color: $grey-text;
  font-weight: 100;
  font-size: 1.125rem;
  line-height: 1.41667rem;

  @include mobile {
    font-size: .75rem;
  }
}

.text {
  color: $grey-text;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 300;

  @include mobile {
    font-size: 0.75rem;
    line-height: 1.125rem;
  }

  a {
    color: $grey-text;
  }
}

.spacer {
  width: 100%;
  height: 1.5rem;
}